<aside class="h-full max-md:ml-0 max-md:w-full">
  <nav
    class="flex flex-col gap-2 pt-6 mx-auto w-full text-sm font-medium whitespace-nowrap shadow-[4px_0px_25px_rgba(0,0,0,0.1)]">
    @for(menu of sideMenu(); track menu.route) {
      <span (click)="navigate($event);side_drawer.toggle();" 
            class="flex items-center gap-3 px-4 py-2 cursor-pointer rounded-md transition-all"
            [class.selected-menu]="selectedRoute() === menu.route"
            [attr.data-route]="menu.route">
        <mat-icon svgIcon="{{menu.menu_icon}}"></mat-icon>           
        <span class="text-sm">{{menu.menu_name}}</span>
      </span>
      <hr class="border-t border-gray-300 mx-4" />
    }
  </nav>
</aside>
